export const income = [
  {
    _id: "5s4fd8df5d",
    key: "level income",
  },
  {
    _id: "4s8fd5f5fd8s7",
    key: "Booster Income",
  },
  {
    _id: "sf8sdfierrfskfj",
    key: "direct income",
  },
  {
    _id: "s8fesfisoifh",
    key: "Franchise Income",
  },
  {
    _id: "s8f8d7s5f1s",
    key: "Club Income",
  },
  {
    _id: "78s5f5df5",
    key: "Binary Income",
  },
  {
    _id: "7fs8f5sersf5",
    key: "Daily Income",
  },
  {
    _id: "994fs7w7ersj",
    key: "Sponsor Income",
  },
  {
    _id: "0skfuweru7s",
    key: "Team Performance Income",
  },
  {
    _id: "f7s8fsfsfsre",
    key: "Matching Income",
  },
  {
    _id: "7f8s9fs5f5sf",
    key: "Autopool Income",
  },
  {
    _id: "478s5fs8e7",
    key: "Reward Income",
  },
  {
    _id: "4s5f5s5fe3",
    key: "Global Matrix Income",
  },
  {
    _id: "7s8f8sf8",
    key: "Royalty Income",
  },
  {
    _id: "s7f8sf8s",
    key: "ROI Income",
  },
  {
    _id: "f7s8fsf8sf",
    key: "CTO Income",
  },
  {
    _id: "7s88s8f",
    key: "Referral Income",
  },
  {
    _id: "f7s8f8sf8",
    key: "Daily Self Team Income",
  },
  {
    _id: "7fs8f5sfs",
    key: "Activation Income",
  },
  {
    _id: "7s8fs8fs8r",
    key: "Joining Income",
  },
];
